import {
  BespokeDesign,
  MobileOptimised,
  SEOOptimised,
  CMS,
  ECommerce,
  ImmersiveEffects,
  Security,
  SocialMedia,
  CustomDevelopment,
  GPDR,
  Discovery,
  Wireframing,
  Design,
  Development,
  Content,
  Testing,
} from '../assets/img/svgs';

// Main Body SECTION
const homePage = {
  hero: {
    title: 'Web Design Agency',
    subtext: 'We are an Award Winning Web Design Agency based in London. ',
    buttons: [
      {
        title: 'View Our Portfolio',
        icon: 'gridSvg',
        link: '#',
      },
      {
        title: 'Start A Project',
        icon: 'arrows',
        link: '#',
      },
    ],
  },
  section1: {
    title: 'A Leading London Web Design Agency',
    gradient_title: 'Creative Brand Design',
    description: [
      <>
        We are an award-winning <strong>London based web design agency</strong>,
        focused on creating bespoke &amp; interactive web experiences for
        aspiring &amp; established businesses and enterprises.
      </>,
      <>
        Our collaborative, phased approach considers all aspects of web design
        &amp; branding, SEO optimization, interactivity, and UI/UX to deliver
        industry leading solutions.
      </>,
      <>
        We specialise on high performance immersive digital experiences aimed at
        delivering our clients a competitive advantage and effective ROI on
        their investment.
      </>,
    ],
    button: {
      text: 'ABOUT US',
      link: '#',
      svg: 'hands',
    },
    media: {
      image: {
        img: require('../assets/img/cbd-mockups.jpg'),
      },
      video1: {
        video: require('../assets/videos/home-arsenal.mp4'),
        img: require('../assets/img/cbd-mockups.jpg'),
      },
      video2: {
        video: require('../assets/videos/genvid-concept.mp4'),
        img: require('../assets/img/cbd-mockups.jpg'),
      },
      video3: {
        video: require('../assets/videos/home-titan.mp4'),
        img: require('../assets/img/cbd-mockups.jpg'),
      },
    },
  },
  recentProject: {
    title: 'Recent web Design Projects',
    gradient_title: 'Beautiful & Interactive Web Design',
    button: {
      text: 'View Full Portfolio',
      link: '#',
      svg: 'eye',
    },
    projects: [
      {
        title: 'Genvid',
        subTitle: 'Design / Development / Hosting',
        img: require('../assets/img/RecentProjects/genvid-cover.webp'),
        link: '#',
      },
      {
        title: 'Alvarium',
        subTitle: 'Design / Development / Hosting',
        img: require('../assets/img/RecentProjects/alvarium-home-cover.webp'),
        link: '#',
      },
      {
        title: 'Kalamaki',
        subTitle: 'Design  Development  Hosting',
        img: require('../assets/img/RecentProjects/street-greeks.webp'),
        link: '#',
      },
      {
        title: 'Intercounty',
        subTitle: 'Design / Development / Hosting',
        img: require('../assets/img/RecentProjects/inter-cover.webp'),
        link: '#',
      },
    ],
  },
  contentImage: {
    title: 'Be More Creative',
    gradient_title: 'Creative Brand Design Team',
    description: [
      <>
        We’re an established, experienced, and trusted{' '}
        <strong>London web design agency</strong> with years of experience in
        providing successful web design solutions.
      </>,
      <>
        An accredited Google Partner working closely with two Google account
        managers, we deliver effective digital marketing insights.
      </>,
      <>
        Our team is formed from UI/UX experts,{' '}
        <strong>skilled web designers</strong>, knowledgeable &amp; creative
        developers, informed digital marketers and dynamic project managers.
      </>,
    ],
    button: {
      text: 'Custom Website Design',
      link: '#',
      svg: 'code',
    },
    media: {
      row1: [
        {
          title: '1',
          img: require('../assets/img/ContentImages/Row1/1.avif'),
        },
        {
          title: '2',
          img: require('../assets/img/ContentImages/Row1/2.avif'),
        },
        {
          title: '3',
          img: require('../assets/img/ContentImages/Row1/3.avif'),
        },
        {
          title: '4',
          img: require('../assets/img/ContentImages/Row1/4.avif'),
        },
      ],
      row2: [
        {
          title: '1',
          img: require('../assets/img/ContentImages/Row2/1.avif'),
        },
        {
          title: '2',
          img: require('../assets/img/ContentImages/Row2/2.avif'),
        },
        {
          title: '3',
          img: require('../assets/img/ContentImages/Row2/3.avif'),
        },
        {
          title: '4',
          img: require('../assets/img/ContentImages/Row2/4.avif'),
        },
        {
          title: '5',
          img: require('../assets/img/ContentImages/Row2/5.avif'),
        },
        {
          title: '6',
          img: require('../assets/img/ContentImages/Row2/6.avif'),
        },
      ],
      row3: [
        {
          title: '1',
          img: require('../assets/img/ContentImages/Row3/1.avif'),
        },
        {
          title: '2',
          img: require('../assets/img/ContentImages/Row3/2.avif'),
        },
        {
          title: '3',
          img: require('../assets/img/ContentImages/Row3/3.avif'),
        },
        {
          title: '4',
          img: require('../assets/img/ContentImages/Row3/4.avif'),
        },
        {
          title: '5',
          img: require('../assets/img/ContentImages/Row3/5.avif'),
        },
        {
          title: '6',
          img: require('../assets/img/ContentImages/Row3/6.avif'),
        },
      ],
      row4: [
        {
          title: '1',
          img: require('../assets/img/ContentImages/Row4/1.avif'),
        },
        {
          title: '2',
          img: require('../assets/img/ContentImages/Row4/2.avif'),
        },
        {
          title: '3',
          img: require('../assets/img/ContentImages/Row4/3.avif'),
        },
        {
          title: '4',
          img: require('../assets/img/ContentImages/Row4/4.avif'),
        },
        {
          title: '5',
          img: require('../assets/img/ContentImages/Row4/5.avif'),
        },
        {
          title: '6',
          img: require('../assets/img/ContentImages/Row4/6.avif'),
        },
      ],
      row5: [
        {
          title: '1',
          img: require('../assets/img/ContentImages/Row5/1.avif'),
        },
        {
          title: '2',
          img: require('../assets/img/ContentImages/Row5/2.avif'),
        },
        {
          title: '3',
          img: require('../assets/img/ContentImages/Row5/3.avif'),
        },
        {
          title: '4',
          img: require('../assets/img/ContentImages/Row5/4.avif'),
        },
      ],
    },
  },
  services: {
    title: 'Overview',
    gradient_title: 'Our Services',
  },
  websiteFeatures: {
    title: 'Our Bespoke Websites',
    gradient_title: 'Include The Following',
    features: [
      {
        title: 'Bespoke Design',
        content: `All of our websites are carefully designed in Adobe
        Creative Suite before being coded by our experienced
        London based web developers, ensuring your site is a
        unique and bespoke design. We have a collaborative
        design process, which considers our client’s feedback
        at every stage, ensuring 100% design satisfaction.`,
        svg: <BespokeDesign />,
      },
      {
        title: 'Mobile Optimised',
        content: `Every website we develop works seamlessly on mobile
        & tablets, ensuring excellent mobile performance
        utilising responsive web design via CSS/JS technology.
        This establishes an optimal viewing experience across
        all devices, fully engaging both your desktop &
        mobile customers.`,
        svg: <MobileOptimised />,
      },
      {
        title: 'SEO Optimised',
        content: `As part of our website development process, our London
        based SEO team will perform onsite optimisation to
        ensure that your website is ranking for the right
        keywords, and employ best practices for user experience
        – positioning your site to generate enquiries and sales.
        Post-launch, we also offer a bespoke SEO strategy so you
        know what steps to take next.`,
        svg: <SEOOptimised />,
      },
      {
        title: 'CMS',
        content: `We are a WordPress CMS web specialist, which allows us
        to adapt and customize a powerful and future proof open
        source CMS to suit your needs. We make use of visual
        editors to create the content of the website’s we
        develop, which allows our clients to easily manage and
        update their website once delivered.`,
        svg: <CMS />,
      },
      {
        title: 'E-Commerce',
        content: `We offer industry-leading, secure, enterprise standard
        e-commerce systems as part of our website development.
        We can adapt e-commerce systems, including Magento and
        WooCommerce, to work seamlessly with your business
        model, whether it be drop shipping, virtual products, or
        international sales.`,
        svg: <ECommerce />,
      },
      {
        title: 'Immersive Effects',
        content: `Our London based web development team code interactive
        elements into your website, to engage and inspire your
        visitors. Our web design team utilize cutting edge
        technologies including jQuery, Canvas, and Webgl to
        deliver an engaging immersive website experience.`,
        svg: <ImmersiveEffects />,
      },
      {
        title: 'Security',
        content: `Security of your website and its data is a key
        consideration of our website development process. As
        such we take steps to ensure that your website and its
        data is kept secure from bots, hackers and virus/malware
        attempts, including reCAPTCHA v3, antivirus &
        firewall technology and limited use of third-party
        software.`,
        svg: <Security />,
      },
      {
        title: 'Social Media',
        content: `Our web design team will build your social media
        accounts into your website using API coding to feature
        the most up to date information & to allow sharing
        of social updates with ease. Our social media
        integration allows you to gain followers & direct
        traffic to your website.`,
        svg: <SocialMedia />,
      },
      {
        title: 'Custom Development',
        content: `All our websites are custom coded on a lightweight
        framework that has been coded by our experienced London
        web design team to current 2021 web design and SEO
        standards, making it highly scalable, agile, and easy to
        adapt. This ensures no excessive bulkiness or code bloat
        – resulting in faster website loading times.`,
        svg: <CustomDevelopment />,
      },
      {
        title: 'GDPR',
        content: `We understand that meeting the new GDPR requirements can
        seem overwhelming. All our websites include a GDPR
        compliancy review, in which our expert web design team
        will carry out tasks based on what we recommend in order
        to ensure GDPR compliance of your website & its data
        processing.`,
        svg: <GPDR />,
      },
    ],
  },
  websiteDesignProcess: {
    gradient_title: 'Our Website Design Process',
    subTitle:
      'Our expert London based web design team follow a bespoke process from start to finish, providing you with unique website designs tailored to your specific requirements.',
    button: {
      text: 'Learn More',
      link: '#',
      svg: 'learnMore',
    },
    designProcess: [
      {
        title: 'Discovery',
        content: `Our team will perform research and discovery to plan and
        inform the phases of the project.`,
        svg: <Discovery />,
      },
      {
        title: 'Wireframing',
        content: `Prior to prototyping the designs, we will create
                        wireframes which plan out the structure and user flow of
                        your website.`,
        svg: <Wireframing />,
      },
      {
        title: 'Design',
        content: `In a collaborative process from end-to-end, the design of
                        the website is created from scratch in Photoshop.`,
        svg: <Design />,
      },
      {
        title: 'Development',
        content: `The final designs from the design phase are used to
                        develop a web version of the site on our staging server.`,
        svg: <Development />,
      },
      {
        title: 'Content',
        content: `The website functionality is developed and content is
                        populated as outlined within the project spec.`,
        svg: <Content />,
      },
      {
        title: 'Testing',
        content: `The website undergoes a full Q&A and interoperability
                        testing procedure, ensuring optimal performance.`,
        svg: <Testing />,
      },
    ],
  },
  latestBlogs: {
    title: 'Read Our News',
    gradient_title: 'Latest Insights',
  },
  smoothieCTA: {
    title: 'Website Design Cost Calculator',
    description: `Use our interactive web design cost calculator tool to plan your
              website design project, and receive a free estimate/proposal from
              our London based team for your web design project.`,

    button: {
      text: 'Plan My Project',
      link: '#',
      svg: 'plan-project',
    },
  },
  reviwes: {
    title: 'References',
    gradient_title: '5 Star Rated',
    reviwes: [
      {
        name: 'Lincoln Hill',
        company: 'Director of External Affairs, Nuclear Industry Association',
        content: `“They created visually appealing designs from scratch and made them look complete and coherent in only three weeks.”`,
      },
      {
        name: 'Dan Pearson',
        company: 'Product Marketing Manager, Genvid',
        content: `“Creative Brand Design produced a visually pleasing and well-functioning site that satisfied all of the client's needs. The team impressed with their ability to understand complex concepts and great attention to detail. They also established an efficient workflow despite the difference in time zones.”`,
      },
      {
        name: 'Sunny Nagra',
        company: 'Chief Marketing Officer, eSmart Systems',
        content: `“They walked us through their entire process, provided us with an accurate timeline estimate, and met all of their deadlines. They’ve also use various collaborative tools where we can look at their designs and comment on them in real-time. I’m very impressed with Creative Brand Design’s process and the time they've taken to deliver something of really good quality.”`,
      },
      {
        name: 'Dimple Athavia',
        company: 'Founder, All Things Drinks',
        content: `“The latest project was creating bespoke landing pages which have increased our average time per page as customers can navigate the range in a more visual format. I would highly recommend them for anybody looking to develop a website and especially to those who have a vision.”`,
      },
      {
        name: 'Marco Fernandes',
        company: 'Operations Director, Cityspec',
        content: `“Our near-decade partnership is enough proof that we find Creative Brand Design as a goal-oriented and reliable team.”`,
      },
      {
        name: 'David Simsey',
        company: 'Campaign Director, Job Growth Organization',
        content: `“Since launching their website, the organization has more than quadrupled the incoming traffic. The internal stakeholders are particularly impressed with the visual aesthetics and high performance of the website. Creative Brand Design was very responsive throughout the development.”`,
      },
      {
        name: 'Nina Ward',
        company: 'InterAmerican Network of Acadamies of Sciences',
        content: `“Had a great experience working with Creative Brand Design. They did a wonderful job redesigning and migrating a website for an organization I work for while addressing all concerns and offering welcomed guidance. With competitive rates and a high standard for client care, I would definitely recommend Creative Brand Design and work with them again.”`,
      },
      {
        name: 'Volker Matz',
        company: 'Director, Matz Management Consulting',
        content: `“Creative Brand Design impresses through an outstanding customer inclusion &amp; support approach whilst designing, prototyping, and developing the website. They ensure full transparency in each step, apply a very contemporary, fresh, and young design with new technical features that makes their developments admirable and exceptional. From User Experience Assessment towards Design and Launch, you're in very capable hands and the outcome will speak for itself.”`,
      },
      {
        name: 'Joe Badger',
        company: 'Director, Joe Badger',
        content: `“All of the team at Creative Brand Design are extremely professional, from day one there communication skills were excellent and they created a fantastic website for my business. For any issue's they responded promptly and the service was brilliant. I would highly recommend Creative Brand Design for any Website Design Projects.”`,
      },
      {
        name: 'Jana Mitackova',
        company: 'Director, Spiral Stabilization',
        content: `“After looking for a website company for a long time I finally found the one that suited my needs. I did some research and Creative Design seemed like a perfect fit and good value for money. I met the team to discuss the project and they were keen, highly motivated and very friendly... I'm delighted with my wonderful new website and I couldn’t be happier. Thank you Creative Brand Design.”`,
      },
      {
        name: 'Edward Stevens',
        company: 'Director, Cranfold Developments',
        content: `“We have been working with CBD since 2013 and have always been impressed with their professional yet personal approach. They took the time to fully understand our requirements and this is reflected in a fresh and innovative website. We would have no hesitation in recommending them.”`,
      },
      {
        name: 'Jacqueline Roberts',
        company: 'Director, Beyond Mountain Bikes',
        content: `“These guys are really professional, helpful and friendly. They offer help as a team which is well coordinated, at a competitive rate. Early days yet, but really pleased with the work they have done.”`,
      },
      {
        name: 'Dean Stirling',
        company: 'Owner, Jabrock Sunglasses',
        content: `“When looking for someone to do a good job in a tight time frame it can prove difficult or expensive. I was very happy with the work done by Creative Brand Design, I had to have a website up and running before the start of my season and they were able to get it done with time to spare.”`,
      },
      {
        name: 'Tamanna Kapour',
        company: 'Crossword Cybersecurity PLC',
        content: `“On behalf of everyone at Crossword, I would like to thank your whole team on your excellent work on our Website. We absolutely love the new design!”`,
      },
    ],
  },
  contactUs: {
    title: 'Interested In Discussing A Project With Us?',
    sub_title: (
      <>
        <p>
          Do you have a project in mind, that you feel our approach would work
          well for?
        </p>
        <p>
          We’re always happy to discuss your project with you and put together a
          free proposal, just fill out the form below or give us a call to get
          started:
        </p>
      </>
    ),
    email: 'info@creativebranddesign.co.uk',
  },
};
const footer = {
  email: 'info@creativebranddesign.co.uk',
  address1: {
    title: '77 New Cavendish Street, London W1W 6XB',
    link: '#',
  },
  address2: {
    title: '136 Madison Avenue, Manhattan, New York, NY 10016',
    link: '#',
  },
  timings: 'Mon-Fri, 9am-6pm',
  socials: {
    twitter: '#',
    facebook: '#',
    linkedin: '#',
    instagram: '#',
  },
  copyrightText:
    '© 2023 Creative Brand Design Ltd. | Registered in England No.08757535',
};

export { homePage, footer };
